module.exports = __webpack_public_path__ + "media/v2/components/Contests/Header/icons/info-ed8bf97b6c4d6f291d5df1622621a989.svg";